module.exports = __webpack_public_path__ + "img/BAU Seniors_5.38425d87.jpg";